import React, { useContext, useMemo } from 'react';
import { GlobalContext } from '../../../store/Store';
import ActionType from '../../../store/ActionType';
// import { StyledTextField } from '../../DatePicker/DatePickerStyles';
import { customDateTimeFormat/* , isDateValid  */} from '../../utils';
import { formatDate } from '../../../mike-shared-helpers/date';
import MikeDatePicker from '../../mike-date-picker';

const InitialDatePicker = () => {
 // const minDate = '1970-01-01';
  //const maxDate = '2030-12-31';

 // const [startDate, setStartDate] = useState(minDate);
  //const [startDateError, setStartDateError] = useState(false);
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const extractionStart = useMemo(() => {
    if (globalState && globalState.mesh && globalState.mesh.extractionInitialDate) {
      return globalState.mesh.extractionInitialDate;
    }
    return globalState.mesh.extractionStartDate;
  }, [globalState]);
 /* useEffect(() => {
    if (extractionStart) {  
      globalDispatch({
        type: ActionType.SET_EXTRACTION_INITIALDATE,
        data: customDateTimeFormat(new Date(extractionStart)),
      });
      globalDispatch({
        type: ActionType.SET_EXTRACTION_INITIAL_PERIOD,
        data: formatDate(extractionStart),
      });
      setStartDate(extractionStart.split('T')[0]);
    } else if (globalState.mesh?.extractionInitialDate === null) {
      globalDispatch({
        type: ActionType.SET_EXTRACTION_INITIALDATE,
        data: new Date(startDate).toISOString(),
      });
      globalDispatch({
        type: ActionType.SET_EXTRACTION_INITIAL_PERIOD,
        data: formatDate(startDate),
      });
    } else {
       const startRange = globalState.mesh?.extractionInitialDate;
      setStartDate(startRange ? startRange.split('T')[0] : minDate); 

      globalDispatch({
        type: ActionType.SET_EXTRACTION_INITIAL_PERIOD,
        data: formatDate(globalState.mesh?.extractionInitialDate),
      });
    }
  }, [extractionStart]);*/


  const onChangeStartDate = (e: Date) => {  
    const isoString = customDateTimeFormat(e)
    globalDispatch({
        type: ActionType.SET_EXTRACTION_INITIALDATE,
        data: isoString,
      });
    globalDispatch({
      type: ActionType.SET_EXTRACTION_INITIAL_PERIOD,
      data: formatDate(e),
    });
  };

  return (
    <MikeDatePicker     
      minDateStart={new Date("1970-01-01")}
      maxDateStart={new Date("2030-12-31")}     
      defaultStartDate={new Date(extractionStart)}
      onChangeStartDate={onChangeStartDate}           
      hideIcon={true}                             
    />
   /*  <>
      <StyledTextField
        type="date"
        fullWidth
        error={startDateError}
        value={startDate}
        InputLabelProps={{
          shrink: true,
          required: startDateError,
        }}
        inputProps={{
          min: minDate,
          max: maxDate,
          onBlur: e => {
            const currentStartDate = new Date(e.target.value);

            const startDateValid = isDateValid(
              currentStartDate,
              new Date(minDate),
              new Date(maxDate)
            );
            setStartDateError(startDateValid);

            if (!startDateValid) {
              globalDispatch({
                type: ActionType.SET_EXTRACTION_INITIALDATE,
                data: currentStartDate.toISOString(),
              });
              globalDispatch({
                type: ActionType.SET_EXTRACTION_INITIAL_PERIOD,
                data: formatDate(currentStartDate),
              });
            }
          },
        }}
        onChange={e => setStartDate(e.target.value)}
      />
    </> */
  );
};
export default React.memo(InitialDatePicker);
